import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, Select, MenuItem, Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
  },
  formControl: {
    minWidth: 300,
  },
  helperText: {
    marginTop: theme.spacing(1),
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
  },
}));

const UserSelector = ({ users, selectedUserId, loggedInUserId, onUserChange, isLoading }) => {
  const classes = useStyles();

  const handleChange = (event) => {
    onUserChange(event.target.value);
  };

  return (
    <Box className={classes.container}>
      <FormControl className={classes.formControl} disabled={isLoading}>
        <InputLabel id="user-selector-label">View Dashboard As User</InputLabel>
        <Select
          labelId="user-selector-label"
          id="user-selector"
          value={selectedUserId || ''}
          onChange={handleChange}
        >
          {users.map((user) => (
            <MenuItem key={user.internalUserId} value={user.internalUserId}>
              {user.firstName} {user.lastName} ({user.internalUserId})
              {user.internalUserId === loggedInUserId && ' - You'}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Typography className={classes.helperText}>
        For testing and IT support: Switch between users to view their dashboard data
      </Typography>
    </Box>
  );
};

UserSelector.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      internalUserId: PropTypes.number.isRequired,
      fullName: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedUserId: PropTypes.number,
  loggedInUserId: PropTypes.number,
  onUserChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

UserSelector.defaultProps = {
  selectedUserId: null,
  loggedInUserId: null,
  isLoading: false,
};

export default UserSelector;
